<template>
    <div>
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col">
                        <div class="card-header-title">
                            <span class="mdi mdi-home-edit-outline mr-2 text-muted"></span> Report Types
                        </div>
                    </div>
                    <div class="col" v-if="reportTypes">
                        <button class="btn btn-primary btn-sm float-right" @click="openItemCreate">
                            <span class="mdi mdi-plus"></span> Add Report Type
                        </button>
                    </div>
                </div>

            </div>
            <div class="card-body">
                <b-table ref="reportTypeTable"
                    small striped borderless
                    :items="reportTypes"
                    :fields="reportTypeFields"
                    v-if="reportTypes && reportTypes.length > 0">
                    <template v-slot:cell(_actions)="data">
                        <div class="float-right">
                            <button class="btn btn-primary btn-sm mr-1" @click="openItemEdit(data.item)">
                                <span class="mdi mdi-file-document-edit-outline"></span>  Edit
                            </button>
                            <button class="btn btn-danger btn-sm mr-1" @click="deleteItem(data.item)" :disabled="data.item.report_count > 0">
                                <span class="mdi mdi-trash-can-outline"></span> Delete
                            </button>
                        </div>                        
                    </template>
                </b-table>

                <!-- Loading info -->
                <div class="d-flex d-flex justify-content-center mt-5 mb-5" v-if="viewState == 'Busy'">
                    <b-spinner variant="secondary" style="width: 1.8rem; height: 1.8rem;"></b-spinner>
                </div>
                <!-- /Loading info -->
            </div>
        </div>

        <b-modal id="modal-update-report-type" 
            modal-ok 
            no-close-on-backdrop 
            ok-title="Save"
            :title="editingItemIsNew ? 'Create Report Type' : 'Edit Report Type'"
            :ok-disabled="!editingItem || (!editingItem.name || !editingItem.code)"
            @ok="onEditModalOK">

            <div v-if="editingItem">
                <div class="form-group">
                    <label for="">
                        Type Code <span v-if="editingItemIsNew">(This cannot be changed after it is created)</span>
                    </label>
                    <input type="text" class="form-control" v-model="editingItem.code" :disabled="!editingItemIsNew">
                </div>

                <div class="form-group">
                    <label for="">Name</label>
                    <input type="text" class="form-control" v-model="editingItem.name">
                </div>
            </div>
        </b-modal>

        <div v-if="viewState == 'Error'">
            <div class="alert alert-danger">
                Something went wrong loading your data, please try again. 
                If the problem persists, please contact the support team.
            </div>
        </div>
    </div>
</template>

<script>
    import ReportTypeService from '../../services/templates/reportTypeService'

    export default {
        data() {
            return {
                viewState: 'Idle',
                error: null,
                reportTypes: null, 
                editingItem: null,
                editingItemIsNew: false,                                
                reportTypeFields: [
                    { key: 'code', label: 'Type Code', tdClass: 'td-report-type' },
                    { key: 'name', label: 'Name', tdClass: 'td-report-type' },
                    { key: 'report_count', label: 'Report Count', tdClass: 'td-report-type' },
                    { key: '_actions', label: '' }
                ]
            }
        },
        async mounted() {
            this.viewState = 'Busy'
            try {
                this.reportTypes = await ReportTypeService.getReportTypes()
                this.viewState = 'Idle'
            } catch (err) {
                this.viewState = 'Error'
                this.error = err
            }
        },
        methods: {
            openItemCreate() {
                this.editingItem = { }
                this.editingItemIsNew = true
                this.$bvModal.show('modal-update-report-type')
            },
            openItemEdit(item) {
                this.editingItemIsNew = false
                this.editingItem = item
                this.$bvModal.show('modal-update-report-type')
            },
            async onEditModalOK(evt) {
                evt.preventDefault()
                if (this.editingItemIsNew) {
                    await this.createItem(this.editingItem)
                }
                else {
                    await this.updateItem(this.editingItem)
                }
                
                this.$bvModal.hide('modal-update-report-type')                
            },
            async createItem(item) {
                try {
                    let newItem = await ReportTypeService.createReportType(this.editingItem)
                    this.reportTypes.push(newItem)
                    this.$bvToast.toast('Report Type created', {
                        title: 'Success',
                        variant: 'success',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                } catch (err) {
                    console.error(err)
                    this.$bvToast.toast('Sorry, something went wrong and we couldn\'t create Report Type', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                }
            },
            async updateItem(item) {
                try {
                    await ReportTypeService.updateReportType(this.editingItem.code, this.editingItem.name)
                    let arrIndex = this.$_.findIndex(this.reportTypes, (t) => {
                        return t.code == this.editingItem.code
                    })

                    this.reportTypes[arrIndex] = this.editingItem                    
                    this.$bvToast.toast('Report Type updated', {
                        title: 'Success',
                        variant: 'success',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                } catch (err) {
                    console.error(err)
                    this.$bvToast.toast('Sorry, something went wrong and we couldn\'t save Report Type', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                }
            },
            deleteItem(item) {
                let msg = `Are you sure you wish to delete '${item.name}'?`
                this.$bvModal
                    .msgBoxConfirm(msg, { centered: true })
                    .then(async (confirm) => {
                        if (confirm) {
                            await ReportTypeService.deleteReportType(item.code)
                            let arrIndex = this.$_.findIndex(this.reportTypes, (t) => {
                                return t.code == item.code
                            })
                            this.$delete(this.reportTypes, arrIndex)
                            this.$bvToast.toast('Report Type deleted', {
                                title: 'Success',
                                variant: 'success',
                                solid: true,
                                appendToast: true,
                                autoHideDelay: 3000
                            })
                        }
                    }).catch((err) => {
                        console.error(err)
                        this.$bvToast.toast('Sorry, something went wrong and we couldn\'t delete the Report Type', {
                            title: 'Error',
                            variant: 'danger',
                            solid: true,
                            appendToast: true,
                            autoHideDelay: 3000
                        })
                    })
            }
        }
    }
</script>

<style lang="scss">
    .td-report-type {
        line-height: 32px;
    }
</style>